
import { defineComponent } from "vue";
import OurCompanyView from "./OurCompanyView.vue";
import ContainerView from "@/components/sections/ContainerView.vue";
import CardView from "@/components/controls/CardView.vue";

export default defineComponent({
    name: "AboutUsView",
    components: {
        OurCompanyView,
        ContainerView,
        CardView
    },
    mounted() {
        this.$emit('scrolltop');
    },
})
